<template>
  <div>
    <div class="mb-2">{{ title }}</div>
    <headFeeDetailPriceEach @onPriceChange="val => (price = val)" @onTypeChange="val => (type = val)" />
    <div class="mb-2">Nhập ghi chú chung</div>
    <v-textarea v-model="notes" outlined label="Ghi chú" />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import headFeeDetailPriceEach from './headFeeDetailPriceEach.vue'
import { sortPeriod } from './helper/period'

export default {
  components: { headFeeDetailPriceEach },
  data() {
    return {
      price: '0',
      type: 'fixed',
      notes: '',
    }
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['router', 'isSubFee']),
    ...mapGetters({
      periods: 'tuitionFeePeriod/periods',
    }),
    title() {
      const titleMiddle = this.getTitlePostfix()
      return `Nhập ${titleMiddle}`
    },
  },
  methods: {
    ...mapActions({ fetchPeriodsIndependent: 'tuitionFeePeriod/fetchPeriodsIndependent' }),
    async getData() {
      const result = {}
      const params = { value: this.price.split(/\s*,\s*/).join(''), type: this.type, notes: this.notes }
      let periods = this.periods
      if (!periods.length) periods = await this.fetchPeriodsIndependent()
      sortPeriod(periods).forEach(item => (result[item.id] = params))
      return result
    },
    getTitlePostfix() {
      if (this.router === 'normal') {
        if (!this.isSubFee) return 'mức đóng'
        return 'mức truy thu'
      }
      if (this.isSubFee) return 'mức hoàn trả'
      return 'mức giảm trừ'
    },
  },
}
</script>
<style lang="scss" scoped>
.input-wrapper {
  width: 100%;
}
.input-wrapper--with-type {
  width: 60%;
}
.type-wrapper {
  width: 40%;
}
</style>
